document.addEventListener('DOMContentLoaded', function () {
	var swiper = new Swiper('.resources-related-swiper-container', {
		slidesPerView: 1,
		spaceBetween: 10,
		navigation: {
			nextEl: '.resources-related-next',
			prevEl: '.resources-related-prev',
		},
		breakpoints: {
			// When window width is >= 600px
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			// When window width is >= 1024px
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			// When window width is >= 1300px
			1300: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
});
